<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Computer Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Academic Achievers'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="7"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Academic Achievers</div>
          <tab-view class="">
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2020-21</span>
              </template>
              <div class="mb-4">
                <div class="heading-black1">BE</div>
                <div class="grid grid-cols-3 gap-5">
                  <achiever-component
                      v-for="(users,index) in getResult('BE','2020-21')"
                      :key="index"
                      :achiever="users">
                  </achiever-component>
                </div>
              </div>
              <div class="heading-black1">ME</div>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('ME','2020-21')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
            <tab-panel>
              <template #header>
                <i class="pi pi-calendar mr-2"></i>
                <span>2019-20</span>
              </template>
              <div class="heading-black1">ME</div>
              <div class="grid grid-cols-3 gap-5">
                <achiever-component
                    v-for="(users,index) in getResult('ME','2019-20')"
                    :key="index"
                    :achiever="users">
                </achiever-component>
              </div>
            </tab-panel>
          </tab-view>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/computer/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import AchieverComponent from "@/components/AchieverComponent";

export default {
  name: "landing-page",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    TabView,
    TabPanel,
    AchieverComponent
  },
  data() {
    return {
      results: [
        {
          year: '2020-21',
          class: 'BE',
          students: [
            {
              name: 'Miss. Rohini More',
              image: '/static/images/computer/academicAchievers/2020-21/Rohini_More.jpg',
              score: 'CGPA - 9.22'
            },
            {
              name: 'Miss. Sonal Naikwade',
              image: '/static/images/computer/academicAchievers/2020-21/Sonal_Naikwade.jpg',
              score: ' CGPA - 9.21'
            },
            {
              name: 'Mr. Mayuri Manjare',
              image: '/static/images/computer/academicAchievers/2020-21/Mayuri_Manjare.jpg',
              score: 'CGPA - 9.20'
            }
          ]
        },
        {
          year: '2020-21',
          class: 'ME',
          students: [
            {
              name: 'Mr. Akshay Bakle',
              image: '/static/images/computer/academicAchievers/2020-21/Akshay_Bakle.jpg',
              score: 'CGPA - 8.90'
            },
          ]
        },
        {
          year: '2019-20',
          class: 'ME',
          students: [
            {
              name: 'Mr. Tushar Sharma',
              image: '/static/images/computer/academicAchievers/2019-20/Tushar_Sharma.jpg',
              score: 'CGPA - 8.55'
            },
          ]
        },
      ]
    }
  },
  methods: {
    getResult(className, year) {

      const s = this.results.filter(item => {
        return item.class === className && item.year === year;
      });

      const result = JSON.parse(JSON.stringify(s))
      // console.log(result[0].students)
      return result[0].students;
    }
  }

}
</script>
<style lang="scss" scoped/>
